import React from 'react';
import type { PortRect } from '../../../types';
import { POE_STANDARD_LABEL, POE_STANDARDS, portLogicKey, type PoEStandard } from '../../../types/deviceModel';
import { useProjectStore } from '../../../store/projectStore';

export function PoeModeSelect({
  equipmentId,
  port,
  face,
  className,
}: {
  equipmentId: string;
  port: PortRect;
  face?: string;
  className?: string;
}) {
  const eq = useProjectStore((s) => s.getCurrentDesign()?.equipment.find((e) => e.id === equipmentId));
  if (!port.poeOut) return null;
  const key = portLogicKey(face || 'front', port.number, String(port.kind));
  const alt = portLogicKey(face || 'front', port.number);
  const cur = eq?.config?.portLogic?.[key] || eq?.config?.portLogic?.[alt];
  const value = cur?.poeMode === 'forced' ? `forced:${cur.forcedStandard}` : cur?.poeMode || 'auto';

  return (
    <select
      className={`bg-slate-700 rounded px-1 py-0.5 text-xs ${className || ''}`}
      value={value}
      onChange={(e) => {
        const v = e.target.value;
        const next = { ...(eq?.config?.portLogic || {}) };
        if (v === 'auto') next[key] = { poeMode: 'auto' };
        else if (v === 'off') next[key] = { poeMode: 'off' };
        else next[key] = { poeMode: 'forced', forcedStandard: v.replace('forced:', '') as PoEStandard };
        useProjectStore.getState().updateEquipmentConfig(equipmentId, { portLogic: next }, { persistToLibrary: false });
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <option value="auto">Auto</option>
      <option value="off">Off</option>
      {(port.poeOut.standards.length ? port.poeOut.standards : POE_STANDARDS).map((s) => (
        <option key={s} value={`forced:${s}`}>
          Forced {POE_STANDARD_LABEL[s]}
        </option>
      ))}
    </select>
  );
}
